<template >
  <base-material-card color="secondary" class="mx-5" icon="mdi-bank">
    <template v-slot:after-heading>
      <div class="display-1 mt-2 font-weight-light">
        {{ $t("admin_panel") }}
      </div>
    </template>
    <v-layout class="mx-12" row>
      <v-tabs
        v-model="tabs"
        background-color="transparent"
        color="secondary"
        slider-color="secondary"
      >
        <v-tab class="mr-3" v-if="RBAC_ente_EDIT_ASD_DATA">
          <v-icon class="mr-2">mdi-bank</v-icon>
          {{ $t("association_management") }}
        </v-tab>
         <v-tab class="mr-3" >
          <v-icon class="mr-2">mdi-handshake-outline</v-icon>
          {{ $t("manage_affiliations") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_ente_EDIT_ASD_DATA">
          <v-icon class="mr-2">mdi-account-group</v-icon>
          {{ $t("manage_council") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_ente_EDIT_ASD_DATA">
          <v-icon class="mr-2">mdi-file-document-outline</v-icon>
          {{ $t("manage_association_document") }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-account</v-icon>
          {{ $t("affiliateds") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_ente_BUY_AFFILIATION_CARD">
          <v-icon class="mr-2">mdi-file-delimited-outline</v-icon>
          {{ $t("sports_club_affiliation_card_management") }}
        </v-tab>
      </v-tabs>
    </v-layout>

    <v-tabs-items v-model="tabs" class="transparent tabs-container">
      <v-tab-item v-if="RBAC_ente_EDIT_ASD_DATA">
        <edit-associazione
          :title="$t('association_management')"
          type="plain"
          method="EDIT"
        />
      </v-tab-item>
      <v-tab-item >
        <edit-affiliazioni
          :title="$t('view_affiliations')"
          type="plain"
          parmsMethod="EDIT"
        />
      </v-tab-item>
      <v-tab-item v-if="RBAC_ente_EDIT_ASD_DATA">
        <edit-consiglio
          :title="$t('manage_council')"
          type="plain"
          parmsMethod="EDIT"
        />
      </v-tab-item>
      <v-tab-item v-if="RBAC_ente_EDIT_ASD_DATA">
        <edit-documenti
          :title="$t('manage_asd_document')"
          type="plain"
          parmsMethod="EDIT"
        />
      </v-tab-item>
      <v-tab-item>
        <list-tesserati />
      </v-tab-item>
      <v-tab-item v-if="RBAC_ente_BUY_AFFILIATION_CARD">
        <user-2-affiliate />
      </v-tab-item>
    </v-tabs-items>
  </base-material-card>
</template>
<script>
import listTesserati from "@/app/ente/listTesserati.vue";
import gestAssociazione from "@/app/ente/gestAssociazione.vue";
import gestConsiglio from "@/app/ente/gestConsiglio.vue";
import gestDocumenti from "@/app/ente/gestDocumenti.vue";
import gestAsdAffiliazioni from "@/app/ente/gestAsdAffiliazioni.vue";
import user2affiliate from "@/widget/user2affiliate.vue";
import listAffiliazioni from "@/app/ente/listAffiliazioni.vue";
 
export default {
  name: "associazione-admin-panel",
  components: {
    "list-tesserati": listTesserati,
    "edit-associazione": gestAssociazione,
    "edit-consiglio": gestConsiglio,
    "edit-affiliazioni": gestAsdAffiliazioni,
    "edit-documenti": gestDocumenti,
    "user-2-affiliate": user2affiliate,
    "list-affiliazioni": listAffiliazioni,
  },

  data() {
    return {
      haveEnte: false,
      tabs: 0,
      RBAC_ente_EDIT_ASD_DATA: false,
      RBAC_ente_BUY_AFFILIATION_CARD: false,
    };
  },
  methods: {},
  created() {
    let _ = this;
    _.haveEnte = window.systemData.haveEnte;
    _.RBAC_ente_EDIT_ASD_DATA = _.checkUserRole("ente", "EDIT_ASD_DATA");
    _.RBAC_ente_BUY_AFFILIATION_CARD = _.checkUserRole(
      "ente",
      "BUY_AFFILIATION_CARD"
    );
  },
  watch: {},
};
</script>
